/**
 * Date and time formatting helpers.
 *
 * Malaysia time (Asia/Kuala_Lumpur, UTC+8). The admin assessment table and
 * the results page header use this so reviewers see the assessment
 * completion timestamp in local Malaysian time regardless of the browser
 * locale or system timezone.
 */

const MYT_TIME_ZONE = 'Asia/Kuala_Lumpur';

// Render the timestamp as a short two-line display:
//   line 1: 15 Feb 2026
//   line 2: 14:32 MYT
export const formatMytShort = (isoString) => {
  if (!isoString) return { date: '-', time: '' };
  const dt = new Date(isoString);
  if (Number.isNaN(dt.getTime())) return { date: '-', time: '' };

  const date = dt.toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: MYT_TIME_ZONE,
  });
  const time = dt.toLocaleTimeString('en-GB', {
    hour: '2-digit', minute: '2-digit', hour12: false, timeZone: MYT_TIME_ZONE,
  });
  return { date, time: `${time} MYT` };
};

// Render the timestamp as a single human-readable line, e.g.
//   "15 Feb 2026, 14:32 MYT"
export const formatMytLong = (isoString) => {
  const { date, time } = formatMytShort(isoString);
  if (date === '-') return '-';
  return `${date}, ${time}`;
};
